var isReactNative = typeof window !== 'undefined' && window.navigator && window.navigator.product && window.navigator.product === 'ReactNative';

export default isReactNative;


//////////////////
// WEBPACK FOOTER
// ../~/redux-form/es/isReactNative.js
// module id = 694
// module chunks = 7